import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import LoginPage from './auth/LoginPage';
import AdminLayout from './admin/AdminLayout';
import DashboardPage from './admin/DashboardPage';
import CustomersPage from './admin/CustomersPage';
import CustomerDetailPage from './admin/CustomerDetailPage';
import QuestionsPage from './admin/QuestionsPage';
import PublicFormPage from './public/PublicFormPage';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/q/:token" element={<PublicFormPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="customers/:id" element={<CustomerDetailPage />} />
          <Route path="questions" element={<QuestionsPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
